module.exports = __webpack_public_path__ + "static/media/11Mocachino.4556eca5.png";